import { useFlags } from "launchdarkly-react-client-sdk";

import { FAX_AUTO_RETRY_FEATURE } from "constants/feature-flags";

import useFaxFailureDetailEnabled from "./use-fax-failure-detail.hook";

/**
 * Whether the fax auto-retry UI (retry line, receipt row, Cancel) is turned on.
 *
 * Requires the failure-detail flag too, on purpose: the retry line renders inside the
 * failure-detail block and describes a classified temporary failure, so auto-retry without
 * failure detail would be a line with no context. Every surface reads the answer through this
 * hook — the three list queries that ask for auto_retry_count/next_retry_at and the status cell
 * that renders them — for the same one-answer reason as useFaxFailureDetailEnabled.
 */
export default function useFaxAutoRetryEnabled(): boolean {
  const flags = useFlags();
  const isFailureDetailEnabled = useFaxFailureDetailEnabled();

  return Boolean(flags[FAX_AUTO_RETRY_FEATURE]) && isFailureDetailEnabled;
}
